import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@frontegg/react';

export default function UnauthenticatedRootPage() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  // Redirect authenticated users away from login page
  if (isAuthenticated) {
    const returnPath = localStorage.getItem('returnPath') || '/';
    localStorage.removeItem('returnPath');
    return <Navigate to={returnPath} replace />;
  }

  return (
    <main className="h-full w-full">
      <Outlet />
    </main>
  );
}

